import { PropsWithChildren } from "react"
import { Navigate, useLocation } from "react-router-dom"
import useSystemNotification from "~/ui-rtk/hooks/useSystemNotification"
import SystemNotification from "~/ui-rtk/components/ui/common/SystemNotification"
import { appendJamParams } from "~/ui-rtk/utils/jamDev"

type TPagePermissionGuardProps = {
  isAllowed: boolean
}

export default function PagePermissionGuard({
  isAllowed,
  children,
}: PropsWithChildren<TPagePermissionGuardProps>) {
  const location = useLocation()
  const { enabled, payload: rawPayload } = useSystemNotification()
  const payload = rawPayload as
    | { type?: string; pages?: string[]; title?: string; message?: string }
    | undefined

  // Check if current page should be blocked based on system notification payload
  const isPageBlocked =
    enabled &&
    payload &&
    payload.type === "block_pages" &&
    payload.pages?.includes(location.pathname)

  if (!isAllowed) {
    return <Navigate to={appendJamParams("/", location.search)} replace />
  }

  if (isPageBlocked) {
    return (
      <div className="p-4 max-w-[600px] mx-auto h-full flex items-center justify-center">
        <SystemNotification
          title={payload?.title}
          content={payload?.message}
          injectable={true}
        />
      </div>
    )
  }

  return children
}
